import orderBy from 'lodash/orderBy'

export const sortTableByKey = (data, fields, directions) => {
  return orderBy(data, [...fields], [...directions])
}

export const culculatePercent = (fieldName, value, totalRowValues) => {
  if (totalRowValues) {
    const onePer = totalRowValues[fieldName] / 100
    return `${Math.round((value / onePer) * 100) / 100}%`
  }

  return ''
}
